import React from 'react'
import styled from 'styled-components'

import { applyTextStyle } from '../../styles/typography'
import { fastTransition, shadows } from '../../styles/effects'

interface IProps {
  count: number
  total: number
  selected?: boolean
  onClick?: () => void
  className?: string
  ariaLabel?: string
}

const InsightsMatrixCountBubble = React.forwardRef<HTMLButtonElement, IProps>(
  ({ count, total, selected, onClick, className, ariaLabel }, ref) => {
    const share = total === 0 ? 0 : count / total
    const size = share > 0.45 ? 96 : share < 0.21 ? 48 : 72
    return (
      <Bubble
        ref={ref}
        type="button"
        className={className}
        $size={size}
        $selected={!!selected}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        {count}
      </Bubble>
    )
  }
)

InsightsMatrixCountBubble.displayName = 'InsightsMatrixCountBubble'

export default InsightsMatrixCountBubble

const Bubble = styled.button<{ $size: number; $selected: boolean }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  border: 2px solid
    ${({ theme, $selected }) =>
      $selected ? theme.colors.primary : theme.colors.lightest};
  background-color: ${({ theme, $selected }) =>
    $selected ? theme.colors.primary : theme.colors.lightest};
  color: ${({ theme, $selected }) =>
    $selected ? theme.colors.lightest : theme.colors.textLight};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${applyTextStyle('title')};
  padding: 0;
  transition: background-color ${fastTransition}, color ${fastTransition},
    border-color ${fastTransition}, box-shadow ${fastTransition};

  &:hover {
    background-color: ${({ theme, $selected }) =>
      $selected ? theme.colors.primary : theme.colors.primaryLight};
    border-color: ${({ theme, $selected }) =>
      $selected ? theme.colors.lightest : theme.colors.primaryLight};
    color: ${({ theme, $selected }) =>
      $selected ? theme.colors.lightest : theme.colors.primary};
    box-shadow: ${shadows.depthThree};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
